import httpClient from './httpClient'

export class SimulationPlanApi {
  static async search(
    accountId,
    advertiserId,
    keyword,
    menuType,
    pageNo,
    pageSize,
    sortOptions,
  ) {
    const res = await httpClient.get('/simulation_plan', {
      params: {
        account_id: accountId,
        advertiser_id: advertiserId,
        keyword: keyword,
        menu_type: menuType,
        page_no: pageNo,
        page_size: pageSize,
        sort_key: sortOptions.sortBy,
        sort_direction: sortOptions.descending ? 'desc' : 'asc',
      },
    })
    return res.data
  }

  static async findById(simulationId) {
    try {
      const res = await httpClient.get(`/simulation_plan/${simulationId}`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async findByHashId(hashId) {
    try {
      const res = await httpClient.get(`/simulation_plan/shared`, {
        params: {
          hash_id: hashId,
        },
      })
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async create(form) {
    try {
      const res = await httpClient.post('/simulation_plan', form)
      return res.data.item
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async update(simulationId, form) {
    try {
      const res = await httpClient.put(`/simulation_plan/${simulationId}`, form)
      return res.data.item
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async delete(simulationId) {
    try {
      return httpClient.delete(`/simulation_plan/${simulationId}`)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async makeHashId(simulationId) {
    try {
      const res = await httpClient.post(
        `/simulation_plan/${simulationId}/make_hash_id`,
      )
      return res.data.item.hashId
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}

export default SimulationPlanApi
